module.exports = __webpack_public_path__ + "img/GIS_Inhuman_Behaviour.cbb092a0.svg";